<template>
  <b-row>
    <b-col cols="12">
      <vue-content-loading :width="300" :height="50" class="my-2">
        <rect x="0" y="0" rx="2" ry="2" width="500" height="100" />
      </vue-content-loading>
    </b-col>
  </b-row>
</template>

<script scoped>
// @ is an alias to /src
import { VueContentLoading } from "vue-content-loading"
export default {
  name: "loading",
  components: {
    VueContentLoading
  },
  mounted() {},
  beforeCreate() {},
  methods: {}
}
</script>
<style>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: black transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
